import type { WizardState, WizardAction } from './types'

export const initialState: WizardState = {
  step: 1,
  items: [],
  selectedAccounts: {},
  selectedYtChannels: {},
  selectedFolderId: '',
  postType: 'feed',
  postTitle: '',
  preferredProfile: '',
  globalCaption: '',
  globalYtTitle: '',
  globalYtDescription: '',
  overrides: {},
  ytTags: '',
  ytPrivacy: 'public',
  scheduleMode: 'now',
  scheduleAt: '',
  spreadStartTime: '08:00',
  spreadEndTime: '20:00',
  dailyTime: '10:00',
  dailyStartDate: '',
  batchInterval: 30,
  category: '',
  customCategory: '',
  antiFingerprint: false,
  ctaSendMessage: false,
  shuffleClips: false,
}

export function wizardReducer(state: WizardState, action: WizardAction): WizardState {
  switch (action.type) {
    case 'SET_STEP':
      return { ...state, step: action.step }
    case 'SET_FIELD':
      return { ...state, [action.field]: action.value }
    case 'ADD_ITEMS':
      return { ...state, items: [...state.items, ...action.items] }
    case 'REMOVE_ITEM':
      return { ...state, items: state.items.filter(i => i.id !== action.id) }
    case 'REORDER_ITEMS': {
      const items = [...state.items]
      const [moved] = items.splice(action.fromIndex, 1)
      items.splice(action.toIndex, 0, moved)
      return { ...state, items }
    }
    case 'TOGGLE_ACCOUNT': {
      const cur = state.selectedAccounts[action.igUserId] || { ig: false, fb: false }
      return {
        ...state,
        selectedAccounts: {
          ...state.selectedAccounts,
          [action.igUserId]: { ...cur, [action.platform]: !cur[action.platform] },
        },
      }
    }
    case 'TOGGLE_YT_CHANNEL':
      return {
        ...state,
        selectedYtChannels: {
          ...state.selectedYtChannels,
          [action.id]: !state.selectedYtChannels[action.id],
        },
      }
    case 'SET_OVERRIDE':
      return { ...state, overrides: { ...state.overrides, [action.itemId]: action.override } }
    case 'CLEAR_OVERRIDE': {
      const { [action.itemId]: _, ...rest } = state.overrides
      return { ...state, overrides: rest }
    }
    case 'RESET':
      return initialState
    default:
      return state
  }
}
